import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowLeft, Calendar } from "lucide-react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";

import INFO from "../data/user";
import myArticles from "../data/articles";

import "./styles/readArticle.css";

const ReadArticle = () => {
	const navigate = useNavigate();
	const { slug } = useParams();
	const [scrollProgress, setScrollProgress] = useState(0);

	const articleFn = myArticles[slug - 1] || myArticles[0];
	const article = articleFn();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [slug]);

	useEffect(() => {
		const handleScroll = () => {
			const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
			if (totalHeight > 0) {
				const currentProgress = (window.scrollY / totalHeight) * 100;
				setScrollProgress(currentProgress);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<React.Fragment>
			<Helmet>
				<title>{`${article.title} | ${INFO.main.name}`}</title>
				<meta name="description" content={article.description} />
				<meta name="keywords" content={article.keywords.join(", ")} />
			</Helmet>

			<div className="reading-progress-bar" style={{ width: `${scrollProgress}%` }} />

			<div className="page-content">
				<NavBar active="articles" />

				<main className="content-wrapper">
					<div className="read-article-container">
						<div className="read-article-body-wrapper">
							<button className="read-article-back-btn" onClick={() => navigate(-1)}>
								<ArrowLeft size={16} />
								<span>Back to Articles</span>
							</button>

							<header className="read-article-header">
								<div className="read-article-date" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
									<Calendar size={14} />
									<span>{article.date}</span>
								</div>
								<h1 className="read-article-title-main">{article.title}</h1>
							</header>

							<div className="read-article-content-body">
								{article.body}
							</div>
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</main>
			</div>
		</React.Fragment>
	);
};

export default ReadArticle;
